import { Market } from '@oneaudi/avp-models';
import { Context, createContext } from 'react';
import { GiveawayResponse, Locale, TaskStatus } from '@oneaudi/avp-hck-dga-customerui-commons';

export const initialState: GiveawayResponse = {
  id: '',
  assets: [],
  marketingCode: '',
  dealerLink: '',
  dealerAddress: '',
  giveawayStatus: TaskStatus.ACCEPTED,
  market: Market.DEU,
  locale: Locale.en,
  carModel: '',
  createdAt: '',
  prString: '',
  updatedAt: '',
  renderCameraFlight: false,
  consumptionAndEmissionData: {
    fuels: {},
  },
  cameraFlightVideo: '',
  oscarConfigId: '',
};

export const GiveawayContext: Context<GiveawayResponse> =
  createContext<GiveawayResponse>(initialState);
